/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Badge, BadgeProps } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { fetchInvoiceCount } from '../../lib/rest/invoiceAPIClient'

export type InvoiceCountBadgeProps = BadgeProps & {
  status: InvoiceStatus;
  type?: InvoiceType;
}

function InvoiceCountBadge (props: InvoiceCountBadgeProps) {
  const { status, type, ...others } = props

  const query = useQuery({
    queryKey: ['invoiceCount', status, type],
    queryFn: () => fetchInvoiceCount({ status, type }),
    refetchInterval: 1000 * 60 * 10
  })
  const count = query.data?.count

  return (
    <Badge
      variant="outline"
      {...others}
      color={count > 0 ? 'red' : 'gray'}
      onClick={() => query.refetch()}
    >
      {count}
    </Badge>
  )
}

export default InvoiceCountBadge
